const baseURL = 'https://api.gyyyfsk.cn';
// const baseURL = 'http://localhost:3000';

//将后台返回的数据转换为图片数据
const mapRawResult = (item: any) => ({
    id: item.id,
    title: item.title,
    description: item.description || '',
    category: item.categoryId || '医学资源',
    path: item.path,
    date: item.updatedAt.substring(0, 10),
    user: item.user || item.User,
    views: item.views || 0,
});

const mapRawResultObj = (item: any) => ({
    id: item.id,
    title: item.title,
    description: item.description || '',
    category: item.categoryId || '医学资源',
    path: item.path,
    date: item.updatedAt.substring(0, 10),
    user: item.user || item.User,
    views: item.views || 0,
});

export { mapRawResult, baseURL, mapRawResultObj };
